<div id="promo-wrapper">
    <section id="promo" class="mt-4 mb-4">
        <div class="container dark">

            <header>
                <h2 i18n>AlbCode - Ihr Integrationspartner für Lexware Office</h2>
            </header>

            <div class="row ms-1 mt-3">
                <div class="col-8 col-12-mobile p-0">
                    <p class="mb-1"><b i18n>Wir implementieren Schnittstellen zwischen Lexware Office und ihren Anwendungen.</b></p>
                    <p i18n>AlbCode ist stolz darauf, ein offizieller Integrationspartner von Lexware Office zu sein. Wir unterstützen Unternehmen dabei, ihre Geschäftsprozesse durch
                        die Integration von Lexware Office zu optimieren. </p>
                </div>
                <div id="integrationspartnerCon" class="col-4 col-12-mobile p-0">
                    <img id="integrationspartner" src="/logos/lexoffice-integrationspartner-badge-bronze.png" alt="" />
                </div>
            </div>
            <div class="row ms-1 mt-3">
                <div class="col p-0">
                    <p class="mb-1"><b i18n>Lexware Office: Buchhaltung & mehr inkl. Zugang für Ihre Steuerkanzlei:</b></p>
                    <ul class="actions">
                        <li><a class="glow-on-hover p-3" href="https://office.lexware.de/?cid=2981&pid=alb&utm_medium=affiliate&utm_source=albcode&utm_campaign=albcode"
                                target="_blank" rel="noopener noreferrer" i18n>Mehr Infos und Lexware Office über AlbCode
                                beziehen und sparen</a></li>
                    </ul>
                </div>
            </div>
            <div class="row ms-1 mt-3">
                <div class="col-8 col-12-mobile p-0">
                    <p class="mb-2"><b i18n>Lexware Office ist „E-Rechnungs-ready“</b></p>
                    <p i18n>Die elektronische Rechnung ist Pflicht! Unternehmen sind seit dem 1. Januar 2025 verpflichtet, im B2B-Bereich elektronische Rechnungen auszustellen. Lexware
                        Office Mandanten müssen sich keine Sorgen machen: Automatisch werden sämtliche gesetzlichen Anforderungen erfüllt.</p>
                </div>
                <div id="erechnungCon" class="col-4 col-12-mobile p-0">
                    <img id="erechnung" src="/lexware/E-Rechnung_Siegel2024_final.png" alt="" />
                </div>
            </div>
        </div>
    </section>
</div>
<div class="wrapper">
    <section class="container">

        <div class="row features justify-content-center">
            <section class="col-12 col-12-narrower feature">
                <header class="major">
                    <h2 i18n>Lexware Office für AlbCode Kunden</h2>
                </header>
                <div class="image-wrapper first">
                    <a href="https://office.lexware.de/?cid=2981&pid=alb&utm_medium=affiliate&utm_source=albcode&utm_campaign=albcode" target="_blank" rel="noopener noreferrer"
                        class="image featured">
                        <div id="lewwareLogo">
                            <img class="p-3" src="/logos/lexoffice.png" alt="" />
                        </div>
                    </a>
                </div>


                <p i18n>Mit der Online-Unternehmenslösung Lexware Office erledigt sich Ihre Buchhaltung fast automatisch.
                    Von der digitalen Belegerfassung über die Rechnungsstellung bis hin zur Buchhaltung in Sekunden.
                    Dank integriertem Online-Banking mit automatischen Zahlungsabgleich sparen Sie sich das mühsame
                    Vergleichen von Belegen und Kontoauszügen. Sie sehen sofort, welche Zahlung zu welchem Beleg
                    gehört und haben immer den vollen Überblick. Lexware Office sorgt automatisch für die korrekte
                    Buchhaltung im Hintergrund und spart Ihnen so jede Menge Zeit.</p>
                <p class="mb-2"><b i18n>Die Lexware Office Vorteile:</b></p>
                <ul>
                    <li i18n>Hohe Zeitersparnis bei Verwaltungsaufgaben (z.B. Monatsrechnungen, Lohnabrechnung)</li>
                    <li i18n>Mobiles Arbeiten per App, Smartphone, Tablet oder Notebook (auch Apple Mac)</li>
                    <li i18n>Einfache Bedienung ohne Buchhaltungskenntnisse</li>
                    <li i18n>Finanzen im Blick in einem Programm (Steuern + Rechnungen + Online-Banking + Buchhaltung)</li>
                    <li i18n>GoBD testiert und Finanzamt-anerkannt</li>
                    <li i18n>DSGVO Datenschutz-konform und rechtssicheres Arbeiten</li>
                    <li i18n>Vom Marktführer „Lexware“ mit jahrzehntelanger Erfahrung</li>
                </ul>


            </section>
        </div>
    </section>
    <br>

    <section class="container">
        <section class="col-12 col-12-narrower feature">
            <header class="major">
                <h2 i18n>Beliebte Funktionen</h2>
            </header>
            <div class="image-wrapper first">
                <div class="image featured"><img src="/lexware/Uebersicht-beliebte-Funktionen_Lexware-Office.jpg" alt="Übersicht beliebte Funktionen Lexware Office" i18n-alt /></div>
            </div>
        </section>
        <section class="col-12 col-12-narrower feature">
            <header class="major">
                <h2 i18n>Übersicht auf dem Dashboard</h2>
            </header>
            <div class="image-wrapper first">
                <div class="image featured"><img src="/lexware/05-LexwareOffice-Dashboard.jpg" alt="Lexware Office Dashboard" i18n-alt /></div>
            </div>
        </section>
        <section class="col-12 col-12-narrower">
            <header class="major">
                <h2 i18n>Auf mehreren Geräten</h2>
            </header>
            <div class="image-wrapper first">
                <div class="image featured"><img src="/lexware/01-LexwareOffice-Funktionen-Dashboard.jpg" alt="Lexware Office Dashboard Funktionen" i18n-alt /></div>
            </div>
        </section>
        <section class="col-12 col-12-narrower feature">
            <header class="major">
                <h2 i18n>Belege mobil erfassen</h2>
            </header>
            <div class="image-wrapper first">
                <div class="image featured"><img src="/lexware/07-LexwareOffice-mobile-Belege.png" alt="Lexware Office mobile Belege" i18n-alt /></div>
            </div>
        </section>
    </section>

    <section class="container mb-4">
        <h2 i18n>Ressourcen</h2>
        <ul style="list-style-type: none;" class="mt-3">
            <li><a href="/lexware/Lexware-Office-Produktinfo-booklet.pdf" target="_blank" rel="noopener noreferrer" i18n>Lexware-Office-Produktinfo-booklet.pdf</a></li>
            <li><a href="F/lexoffice/Factsheet-lexwareOffice.pdf" target="_blank" rel="noopener noreferrer" i18n>Factsheet-lexwareOffice.pdf</a></li>
        </ul>
    </section>

    <section class="container mb-4 p-0">
        <h2 i18n>Testsieger Lexware Office - Automatische Online-Buchhaltung</h2>
        <div class="ratio ratio-16x9 mb-4 mt-3">
            <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/mNP94c9iGxA?si=oMuLmYncBPetaG2a" title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen i18n-title></iframe>
        </div>
        <br>

        <ul class="actions d-inline">
            <li><a class="glow-on-hover p-3" href="https://office.lexware.de/?cid=2981&pid=alb&utm_medium=affiliate&utm_source=albcode&utm_campaign=albcode" target="_blank"
                    rel="noopener noreferrer" i18n>Mehr
                    Infos und Lexware Office über AlbCode
                    beziehen und sparen</a></li>
        </ul>
    </section>
</div>